import { Button } from '@mui/material';
import { errorMonitor } from 'events';
import React from 'react';


class ErrorBoundary extends React.Component<any,{hasError:boolean, errorMessage:string}> {
  constructor(props:any) {
    super(props);
    this.state = { hasError: false, errorMessage: "" };
  }

  static getDerivedStateFromError(error:any) {
    return { hasError: true };
  }

  componentDidCatch(error:any, errorInfo:any) {
    this.setState({errorMessage:error?.toString()});
  }

  render() {


    if (this.state.hasError) {
      return (
        <div style={{ textAlign: 'center' }}>
          <h3 style={{ margin: '20px 0' }}>
            متن خطا: 
          </h3>
          <code style={{ margin: '20px 0' }}>
            {this.state.errorMessage}
          </code>
          <div>
          <Button
            size="medium"
            variant='contained'
            color='primary'
            onClick={() => window.location.reload()}
          >
            <div style={{ padding: '0 10px' }}>
            تلاش دوباره
            </div>
          </Button>
          </div>
        </div>
      );
    }

    return this.props.children; 
  }
}

export default ErrorBoundary;